export enum HandleErrorEventType {
	BootstrapError = 'RxAppBootstrapError',
	InitializeError = 'RxAppInitializationError',
	ClosingError = 'RxAppCloseError',
	SaveError = 'RxAppSaveError',
	SavedError = 'RxAppSavedError',
	ValidationError = 'RxAppValidationError',
	SleeveConfirmationError = 'RxAppSleeveConfirmationError',
	UpdatePlatformErrorTimeoutError = 'RxAppUpdatePlatformErrorTimeoutError',
	SessionUpdateError = 'RxAppSessionUpdateError',
	RxChangeImplantsViewAppParametersError = 'RxAppRxChangeImplantsViewAppParametersError',
	ClosingRejectedError = 'RxAppClosingRejectedError'
}

/*
 * The header and description are supposed to be internationalized once requirements are secured.
 * */
export const handleErrorEventHeader = {
	[HandleErrorEventType.BootstrapError]: 'Unable to bootstrap RxApp application.',
	[HandleErrorEventType.InitializeError]: 'Unable to initialize RxApp application.',
	[HandleErrorEventType.ClosingError]: 'Unable to close RxApp application.',
	[HandleErrorEventType.SaveError]: 'Unable to save RxApp application.',
	[HandleErrorEventType.SavedError]: 'Unable to send Saved RxApp event.',
	[HandleErrorEventType.ValidationError]: 'Unable to send validation failure event.',
	[HandleErrorEventType.SleeveConfirmationError]: 'Unable to send sleeve confirmation event.',
	[HandleErrorEventType.UpdatePlatformErrorTimeoutError]: 'Unable to update scanner error timeout.',
	[HandleErrorEventType.SessionUpdateError]: 'Unable to update session info for RxApp application.',
	[HandleErrorEventType.RxChangeImplantsViewAppParametersError]: 'Unable to send new implants view app parameters.',
	[HandleErrorEventType.ClosingRejectedError]: 'Unable to send closing rejected event.'
} as const;
